export enum ConnectionError {
  ConnectionAlreadyExists = 'Connection already exists',
  MaxSentApplicationsPerDay = 'Max sent applications threshold reached',
  ScoringError = 'Scoring error',
}
